import React from "react";
import "./DeltaCard.scss";

interface IProps {
  item: any;
  isRemitted: boolean;
  checked: boolean;
  showRemesar: boolean;
  onRemit: (id: string) => void;
  onEdit: (id: string) => void;
}

const DeltaCardConBaja: React.FC<IProps> = ({
  item,
  isRemitted,
  checked,
  showRemesar,
  onRemit,
  onEdit,
}) => (
  <div className={`delta-result-card${item.Remesado ? " delta-result-card--remesado" : " delta-result-card--no-remesado"}`}>
    <div className="delta-result-card__header">
      <span className="delta-result-card__tipo">Exp: {item.ExpedienteId}</span>
      <div className="delta-result-card__status-pills">
        <span
          className={`delta-result-card__status-pill ${item.Validacion ? "delta-result-card__status-pill--ok" : "delta-result-card__status-pill--ko"}`}
          title={item.Validacion ? "Validado" : "Sin validar"}
        >
          {item.Validacion ? "Validado" : "Sin validar"}
        </span>
        <span
          className={`delta-result-card__status-pill ${item.Remesado ? "delta-result-card__status-pill--ok" : "delta-result-card__status-pill--ko"}`}
          title={item.Remesado ? "Remesado" : "Sin remesar"}
        >
          {item.Remesado ? "Remesado" : "Sin remesar"}
        </span>
      </div>
    </div>

    <div className="delta-result-card__body">
      <div className="delta-result-card__field">
        <span className="delta-result-card__label">DNI/NIE</span>
        <span className="delta-result-card__value">{item.IPF}</span>
      </div>
      <div className="delta-result-card__field">
        <span className="delta-result-card__label">Trabajador</span>
        <span className="delta-result-card__value">
          {[item.Nombre, item.Apellido1, item.Apellido2].filter(Boolean).join(" ")}
        </span>
      </div>
      <div className="delta-result-card__field">
        <span className="delta-result-card__label">CCC</span>
        <span className="delta-result-card__value">{item.CCC}</span>
      </div>
      <div className="delta-result-card__row-double">
        <div className="delta-result-card__field">
          <span className="delta-result-card__label">F. Accidente</span>
          <span className="delta-result-card__value">{item.formatted_accident_date}</span>
        </div>
        <div className="delta-result-card__field">
          <span className="delta-result-card__label">F. Baja</span>
          <span className="delta-result-card__value">{item.formatted_leaving_date}</span>
        </div>
      </div>
      {isRemitted && item.Estado && (
        <div className="delta-result-card__field">
          <span className="delta-result-card__label">Estado</span>
          <span className="delta-result-card__value delta-result-card__value--estado">
            {item.Estado}
          </span>
        </div>
      )}
    </div>

    <div className="delta-result-card__footer">
      {showRemesar && (
        <label
          className={`delta-result-card__remesar-label${
            !item.Validacion ? " delta-result-card__remesar-label--disabled" : ""
          }`}
        >
          <input
            type="checkbox"
            checked={checked}
            onChange={() => onRemit(item.Id)}
            disabled={!item.Validacion}
          />
          <span>Remesar</span>
        </label>
      )}
      <button className="delta-result-card__action-btn" onClick={() => onEdit(item.Id)}>
        <span className="edit-delta-icon" />
        {isRemitted ? "Ver" : "Editar"}
      </button>
    </div>
  </div>
);

export default React.memo(DeltaCardConBaja);
